import Link from 'next/link'
import { Close } from 'react-components/atoms/Icons'

function Evidenza({ item, selected = false, onClick = () => {}, className = '' }) {
  const classes = `evidenza ${selected ? 'evidenza--selected' : ''} ${className}`

  if (item.url)
    return (
      <Link legacyBehavior href={item.url}>
        <a className={classes} title={item.nome} onClick={onClick}>
          {item.nome}
        </a>
      </Link>
    )
  else
    return (
      <span className={classes} onClick={onClick}>
        {item.nome} {selected && <Close />}
      </span>
    )
}

export default Evidenza
